export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_957_ACKNOWLEDGE': 'Acknowledge',
    '_109_ALL': 'All',
    '_763_CLOSE': 'Close',
    '_956_HIGH_PRIORITY_ALERT_RECEIVED': 'High Priority Alert Received',
    '_110_NOTHING_HERE': 'Nothing here',
    '_690_READ_LESS': 'read less',
    '_689_READ_MORE': 'read more'
};
